import { useState, useEffect } from 'react'
import Styles from './styles.module.sass'
import { API_EXCEPTION, BASE_PATH_API, STAGE_DIRNAME } from 'constants/env'
import GiftsHeader from 'newComponents/GiftsHeader/GiftsHeaderNavigate';
import { useHistory } from 'react-router-dom'
import PaginationList from 'newComponents/pagination'
import { useStore } from 'store'
import { showLoader, hideLoader } from 'store/actions/commons';
import { withLayout, withAgentPage } from 'hocs'
import compose from 'recompose/compose'

const OrderAsk = 'ASC'
const OrderDesk = 'DESC'
const text0 = 'Fecha más cercana'
const text1 = 'Fecha más lejana'

const useSearchGifts = () => {

    const [ , dispatch ] = useStore( (state) => state?.giftTable?.myListOfGiftsTables?.results?.list )

    /* Funciones y logica para el llenado de Eventos */
    const [ preEventos, setPreEventos ] = useState([])
    const [ eventos, setEventos ] = useState([])
    const [ errorService, setErrorService ] = useState()
    const [ errorServer, setErrorServer ] = useState([])
    const [ hiddenSearch, setHiddenSearch ] = useState(false)
    const cantResponse = 14
    const initOrderBy = OrderAsk
    
    const getEvents = async () =>  {
        const config = {
            method: 'GET',
            withCredentials: true,
            redirect: 'follow',
            timeout: 25,
        }
        dispatch(showLoader())
        let apiURL = `${BASE_PATH_API}/gift-table/v1/event`
        try{
            const response = await fetch( apiURL, config )
            const statusCode = response.status;
            if(response.ok){
                const data = await response.json();
                if(statusCode >= 401 && statusCode <= 403){
                    setErrorService(statusCode)
                    dispatch(hideLoader())
                }
                dispatch(hideLoader())
                setPreEventos(data?.data)
            }else{
                if(statusCode >= 404 && statusCode <= 499){
                    setErrorService(statusCode)
                    dispatch(hideLoader())
                }
                else if(statusCode >= 500 && statusCode <= 510){
                    setErrorServer(statusCode)
                    dispatch(hideLoader())
                }
            }
            
        } catch (error) {
            console.error('Error fetching cmsProductGet data:', error);
        }
    }
    useEffect(()=>{
        getEvents()
    },[])
    useEffect(()=>{
        if(preEventos){
            const totalEventos = []
            preEventos.map(pre => {
                const PE = pre.events
                PE.map(even => {
                    return totalEventos.push(even) 
                })
            })
            setEventos(totalEventos)
        }
    },[preEventos])



    /* Funciones y logicas para respuesta de eventos */
    const [ resultGifts, setResultGifts ] = useState('')
    const getSearch = async (paramsFilter) =>  {
        dispatch(showLoader())         
        const config = {
            method: 'GET',
            withCredentials: true,
            redirect: 'follow',
            timeout: 25,
        }

        let apiURL = `${BASE_PATH_API}/gift-table/v1/search${paramsFilter}`
        try{
            const response = await fetch( apiURL, config )
            const statusCode = response.status;

            if(response.ok){
                const data = await response.json();
                
                if(statusCode >= 401 && statusCode <= 403){
                    setErrorService(statusCode)
                    dispatch(hideLoader())
                }
                setResultGifts(data?.data) 
                dispatch(hideLoader())
                setHiddenSearch(true)
            }else{
                const errorData = await response.json();

                if(statusCode >= 404 && statusCode <= 499){
                    setErrorService(statusCode)
                    dispatch(hideLoader())
                    setHiddenSearch(true)
                }
                else if(statusCode === 400){
                    setErrorService(errorData?.metadata)
                    dispatch(hideLoader())
                    setHiddenSearch(true)
                }
                else if(statusCode >= 500 && statusCode <= 510){
                    setErrorServer(statusCode)
                    dispatch(hideLoader())
                    setHiddenSearch(true)
                }
            }
            
        } catch (error) {
            console.error('Error fetching cmsProductGet data:', error);
        }
    }

    const [ getResponse, setGetResponse ] = useState()
    const [ pageNumber, setPageNumber ] = useState(1)
    const [ orderBy, setOrderBy ] = useState(initOrderBy)
    const sendSearch = (props) => {
        const {
            noEvent,
            nombre,
            apellido,
            tipoEvento,
            fechaInicio,
            fechaFin
        } = props

        let respuesta
        let rTipoEvento = tipoEvento ? `&event_type_id=${tipoEvento}`: ''
        let rFechas = fechaInicio ? `&range_start_date=${fechaInicio}&range_end_date=${fechaFin}`: ''
        let nombreSan = nombre ? nombre.trim() : ''
        let apellidoSan = apellido ? apellido.trim() : ''

        if(noEvent){
            respuesta = `?gifttable_id=${noEvent}${rTipoEvento}${rFechas}`
        }else{
            respuesta = `?celebrate_name=${nombreSan}&celebrate_lastname=${apellidoSan}${rTipoEvento}${rFechas}`
        }
        setPageNumber(1)
        setGetResponse(respuesta)
    }

    useEffect(()=>{
        if(getResponse){
            setErrorServer([])
            setErrorService()
            setResultGifts('')
            setHiddenSearch(false)
            if(pageNumber){
                getSearch(getResponse+`&page=${pageNumber}&limit=${cantResponse}&order=${orderBy}`)
            }else{
                getSearch(getResponse+`&page=1&limit=${cantResponse}&order=${orderBy}`)
            }
        }

    },[getResponse, pageNumber, orderBy])


    /* Funciones y logicas de fechas */
    const [ fechaUD, setFechaUD ] = useState()
    const [ fechas, setFechas ] = useState({})
    const [ fechasUpdate, setFechasUpdate ] = useState({})

    const generarFechas = (diasArray) => {
        return diasArray.map(dias => {
            let fecha = new Date();
            fecha.setDate(fecha.getDate() + dias);
            return formatearFecha(fecha);
        });
    }
    const ajustarFechaConBase = (fechaBase, diasArray) => {
        return diasArray.map(dias => {
            let fecha = new Date(fechaBase);
            fecha.setDate(fecha.getDate() + dias);
            return formatearFecha(fecha);
        });
    }
    const formatearFecha = (fecha) => {
        let año = fecha.getFullYear();
        let mes = String(fecha.getMonth() + 1).padStart(2, '0');
        let dia = String(fecha.getDate()).padStart(2, '0');
        return `${año}-${mes}-${dia}`;
    }

    let dias = [-90, 395, 90, 575]
    useEffect(()=>{
        let fechasGeneradas = generarFechas(dias);
        setFechas({
            FIMin: fechasGeneradas[0],
            FIMax: fechasGeneradas[1],
        })
        setFechasUpdate({
            FFMin: fechasGeneradas[3],
            FFMax: fechasGeneradas[4],
        })
    },[])
    let diasHasta = [2, 180]
    useEffect(()=>{
        if(fechaUD){
            let fechaHasta = ajustarFechaConBase(fechaUD, diasHasta)
            setFechasUpdate({
                FFMin: fechaHasta[0],
                FFMax: fechaHasta[1],
            })
            setFechaUD(null)
        }
    },[fechaUD])


    return {
        resultGifts,
        eventos,
        fechas,
        fechasUpdate,
        errorService,
        hiddenSearch,
        initOrderBy,
        setFechaUD,
        sendSearch,
        setPageNumber,
        setOrderBy
    }
}


const ModuleSearchTable = (props) => {
    const {
        setResults,
        setBusqueda,
        selectPage,
        setSearchResults,
        setErrorService,
        setInitOrder,
        selectOrder
    } = props

    const {
        resultGifts,
        eventos,
        fechas,
        fechasUpdate,
        errorService,
        hiddenSearch,
        initOrderBy,
        setFechaUD,
        sendSearch,
        setPageNumber,
        setOrderBy
    } = useSearchGifts()


    const initData = {}
    const [ searchData, setSearchData ] = useState(initData)
    const [ filter, setFilter ] = useState(0)
    const [ fFDisabled, setFFDisabled] = useState(true)


    const porEvento = () => {
        setFilter(0)
        delete searchData?.nombre
        delete searchData?.apellido
    }
    const porNombre = () => {
        setFilter(1)
        delete searchData?.noEvent
    }

    const limpiarCadena = (texto) => {
        // Eliminar sentencias SQL
        const palabrasSQL = /(\b(SELECT|INSERT|DELETE|UPDATE|DROP|ALTER|CREATE|EXEC|UNION|WHERE|FROM|INTO|VALUES|SET|TABLE|DATABASE)\b)/gi;
        texto = texto.replace(palabrasSQL, '');
      
        // Eliminar etiquetas HTML
        const etiquetasHTML = /(<([^>]+)>)/gi;
        texto = texto.replace(etiquetasHTML, '');

        // Eliminar caracteres especiales peligrosos
        const caracteresPeligrosos = /[;'"\\]/g;
        texto = texto.replace(caracteresPeligrosos, '');
      
        return texto;
      }

    const handleSubmit = (e) => {
        e.preventDefault()
        if(filter === 0){
            let valEvent = searchData?.noEvent ? String(searchData?.noEvent) : ''
            if(valEvent?.length >= 3){
                sendSearch(searchData)
            }
        }else if(filter === 1){
            let valName = searchData?.nombre ? searchData?.nombre : ''
            let valPatern = searchData?.apellido ? searchData?.apellido : ''
            let busquedaName = `${valName} ${valPatern}`
            if(valName?.length >= 3 && valPatern?.length >= 3){
                sendSearch(searchData)
                setBusqueda(busquedaName)
            }
        }
    }

    const handleChange = (event) =>{
        const {
            value,
            name
        } = event.target
        
        if(name === 'nombre'){

            setSearchData({
                ...searchData,
                [name]: value ? limpiarCadena(value) : ''
            })
        }
        else if(name === 'apellido'){
            setSearchData({
                ...searchData,
                [name]: value ? limpiarCadena(value) : ''
            })
        }
        else if(name === 'noEvent'){
            let numberEvent = value.replace(/[^\d]+/g,'')
            setSearchData({
                ...searchData,
                [name]: numberEvent ? Number(numberEvent) : ''
            })
        }
        else if(name === 'tipoEvento'){
            let numberEvent = value.replace(/[^\d]+/g,'')
            setSearchData({
                ...searchData,
                [name]: numberEvent ? Number(numberEvent) : ''
            })
        }
        else{
            setSearchData({
                ...searchData,
                [name]: value
            })
        }
    }

    useEffect(()=>{
        if(initOrderBy){
            setInitOrder(initOrderBy)
        }
    },[initOrderBy])

    useEffect(()=>{
        if(selectOrder){
            setOrderBy(selectOrder)
        }
    },[selectOrder])

    useEffect(()=>{
        if(resultGifts){
            setResults(resultGifts)
        }
    },[resultGifts])
    
    useEffect(()=>{
        if(hiddenSearch){
            setSearchResults(true)
        }
    },[hiddenSearch])

    useEffect(()=>{
        if(searchData){
            if(searchData?.fechaInicio?.length >= 1){
                setFFDisabled(false)
                setFechaUD(searchData?.fechaInicio)
            }else if(searchData?.fechaInicio?.length === 0 ||searchData?.fechaInicio === undefined ){
                setFFDisabled(true)
                if(document.querySelector('#fechaFin')){
                    document.querySelector('#fechaFin').value = ''
                }
                delete searchData?.fechaInicio
                delete searchData?.fechaFin
            }

            if(searchData?.tipoEvento?.length === 0 ||searchData?.tipoEvento === undefined ){
                delete searchData?.tipoEvento
            }
        }
    },[searchData])

    useEffect(()=>{
        if(errorService){
            setErrorService(errorService)
        }else{
            setErrorService()
        }
    },[errorService])

    useEffect(()=>{
        if(selectPage){
            setPageNumber(selectPage)
        }
    },[selectPage])

    return(
        <div className={Styles?.contentCardSearch}>
            <h1>Buscar mesa de regalos</h1>
            <p className={Styles?.subTitle}>Puedes buscar la mesa de regalos con alguno de los siguientes datos:</p>
            <div>
                <p className={Styles?.steps}>Selecciona una opción:</p>
                <div 
                    onClick={porEvento}
                    className={filter === 0 ? `${Styles?.selectFilter} ${Styles?.active}` : Styles?.selectFilter}
                    >Número de evento</div>
                <div 
                    onClick={porNombre}
                    className={filter === 1 ? `${Styles?.selectFilter} ${Styles?.active}` : Styles?.selectFilter}
                >Nombre y apellido</div>
            </div>
            <form onSubmit={handleSubmit}>
                {filter === 0
                    ?
                        <fieldset>
                            <label>
                                <span className={Styles?.titleLabel}>Número de evento*</span>
                                <input
                                    id="noEvent"
                                    name="noEvent"
                                    placeholder="Ingresa un número de evento"
                                    onChange={handleChange}
                                    value={searchData?.noEvent}
                                    type="text" 
                                    autoComplete='off'
                                    required
                                />
                            </label>
                        </fieldset>
                    : filter === 1
                        ?
                            <>
                                <fieldset>
                                    <label>
                                        <span className={Styles?.titleLabel}>Nombre(s)*</span>
                                        <input 
                                            id="nombre"
                                            name="nombre"
                                            placeholder="Ingresa un nombre"
                                            onChange={handleChange}
                                            value={searchData?.nombre}
                                            type="text" 
                                            autoComplete='off'
                                            required
                                        />
                                    </label>
                                </fieldset>
                                <fieldset>
                                    <label>
                                        <span className={Styles?.titleLabel}>Apellido paterno*</span>
                                        <input 
                                            id="apellido"
                                            name="apellido"
                                            placeholder="Ingresa un apellido"
                                            onChange={handleChange}
                                            value={searchData?.apellido}
                                            type="text"
                                            autoComplete='off'
                                            required
                                        />
                                    </label>
                                </fieldset>

                                <fieldset>
                                    <label>
                                        <span className={Styles?.titleLabel}>Tipo de evento</span>
                                        <select
                                            id="tipoEvento"
                                            name="tipoEvento"
                                            onChange={handleChange}
                                            value={searchData?.tipoEvento}
                                        >
                                            <option value="" >Selecciona un tipo de evento</option>
                                            {eventos?.length >= 1
                                                ? eventos?.map((eventType, index) => {
                                                    return(
                                                        <option value={eventType?.id} key={index} >{eventType?.name}</option>
                                                    )
                                                })
                                                : null
                                            }
                                        </select>
                                    </label>
                                </fieldset>

                                <fieldset>
                                    <label>
                                        <span className={Styles?.titleLabelMore}>Fecha estimada del evento</span>
                                        <span className={Styles?.titleLabel}>Desde</span>
                                        <input
                                            id="fechaInicio"
                                            name="fechaInicio"
                                            placeholder="dd/mm/aaaa"
                                            onChange={handleChange}
                                            value={searchData?.fechaInicio}
                                            type="date"
                                            autoComplete='off'
                                            min={fechas?.FIMin}
                                            max={fechas?.FIMax}
                                        />
                                    </label>
                                </fieldset>
                                
                                <fieldset>
                                    <label>
                                        <span className={Styles?.titleLabel}>Hasta</span>
                                        <input
                                            id="fechaFin"
                                            name="fechaFin"
                                            placeholder="dd/mm/aaaa"
                                            onChange={handleChange}
                                            value={searchData?.fechaFin}
                                            type="date"
                                            disabled={fFDisabled}
                                            autoComplete='off'
                                            min={fechasUpdate?.FFMin}
                                            max={fechasUpdate?.FFMax}
                                        />
                                    </label>
                                </fieldset>
                            </>
                        : null
                }
                
                <fieldset>
                    <label>
                        <button className={Styles?.buttonSearch}>Buscar</button>
                    </label>
                </fieldset>
            </form>
        </div>
    )
}


const ModuleResults = (props) => {
    const {
        results,
        errorService,
        busqueda,
        setSelectPage,
        setSearchResults,
        setSelectOrder,
        selectOrder,
        initOrder
    } = props

    const history = useHistory();

    const [ response, setResponse ] = useState()
    const [ pagination, setPagination ] = useState()
    const [ firstT, setFirstT ] = useState(false)
    const [ changeOB, setchangeOB ] = useState(true)
    const [ dateTextBy, setDateTextBy ] = useState(text1)

    const sendLink = (link) => {
        history.push(link)
    }

    const formatDate = (date) => {
        const meses = [ 'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']
        const fechaSect = date.split('-')
        const posMes = Number(fechaSect[1]) -1
        const newDate = `${fechaSect[2]} ${meses[posMes]} ${fechaSect[0]}`
         return newDate
    }

    const changeOrderBy = () => {
        setchangeOB(!changeOB)
    }
    
    useEffect(()=>{
        if(initOrder === OrderAsk){
            setSelectOrder(OrderAsk)
        }
    },[initOrder])

    useEffect(()=>{
        if( changeOB ){
            setSelectOrder(OrderAsk)
        }else{
            setSelectOrder(OrderDesk)
        }
    },[ changeOB ])

    useEffect(()=>{
        if(selectOrder === OrderAsk){
            setDateTextBy(text0)
        }else{
            setDateTextBy(text1)
        }
    },[ selectOrder ])

    useEffect(()=>{
        if(results){
            if(results?.pagination || results?.count >= 1){
                setPagination(results?.pagination)
            }else{
                setPagination(null)
            }
            setResponse(results?.results)
            setFirstT(true)
        }
    },[results])

    useEffect(()=>{
        if(errorService){
            setResponse(null)
        }
    },[errorService])
    
    useEffect(()=>{
        if(response){
            // console.log('response1 ',response) 
        }
    },[response])

    const closeSearch = () => setSearchResults(false)

    return(
        <div className={Styles?.contentResults}>
            <div className={Styles?.returnToSearch} onClick={closeSearch}>Nueva busqueda</div>
            
            {response?.length >= 1
                ?
                    <div className={Styles?.resultsList}>
                        <h2>Resultados de la búsqueda.</h2>
                        {pagination
                            ?
                                <>
                                    <p className={Styles?.countResults}>Encontramos {pagination?.total_results} resultados de búsqueda para “{busqueda}”.</p>
                                    <div className={Styles?.contentOrders}>
                                        {/* <div className={Styles?.orderEvent}>Tipo de evento</div> */}
                                        <div 
                                            className={Styles?.orderDate}
                                            onClick={changeOrderBy}
                                        >{dateTextBy}</div>
                                    </div>
                                </>
                            : null
                        }

                        <div className={`${Styles?.cellResults} ${Styles?.titles}`} >
                            <p className={Styles?.titleResult}>Nombre</p>
                            <p className={Styles?.eventResult}>Evento</p>
                            <p className={Styles?.otherResult}>No. Evento</p>
                            <p className={Styles?.dateResult}>Fecha</p>
                        </div>

                        {response?.map((result, index) => {

                            const festejados = result?.celebrates[1] ? `${result?.celebrates[0]?.first_name} ${result?.celebrates[0]?.last_name} & ${result?.celebrates[1]?.first_name} ${result?.celebrates[1]?.last_name}` : `${result?.celebrates[0]?.first_name} ${result?.celebrates[0]?.last_name}`
                            const evento = result?.gifttable?.event?.type
                            const fecha = result?.gifttable?.date.split(' ')[0]
                            const urlLink = `/${result?.gifttable?.id}/${result?.gifttable?.name?.replace(/ /g, "-")}` 
                            return(
                                <div 
                                    className={Styles?.cellResults} 
                                    // onClick={() => sendLink(urlLink)}
                                    key={index}
                                >
                                    <p className={Styles?.titleResult}>{festejados}</p>
                                    <p className={Styles?.eventResult}>
                                        <span className={Styles?.mov}> - </span>
                                        {evento}
                                    </p>
                                    <p className={Styles?.otherResult}>
                                        <span className={Styles?.desk}>#</span>
                                        <span className={Styles?.mov}>Mesa: </span>
                                        {result?.gifttable?.id}
                                    </p>
                                    <p className={Styles?.dateResult}>{formatDate(fecha)}</p>
                                    <p 
                                        className={Styles?.linkResult} 
                                        onClick={() => sendLink(urlLink)}
                                    >
                                        <span className={Styles?.desk}>ver</span>
                                        <span className={Styles?.mov}> &gt;</span>
                                    </p>
                                </div>
                            )
                            }
                        )}

                        {pagination
                            ?
                                <div className={Styles?.contPagination}>
                                    <PaginationList
                                        setPage={setSelectPage}
                                        selectedPage={pagination?.page || 1}
                                        cantResults={pagination?.total_results}
                                        cantResultPerPage={pagination?.page_size}
                                    />
                                </div>
                            : null
                        }
                    </div>
                :
                    errorService
                        ?
                            <div className={Styles?.contNoResults}>
                                <img src="https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/img/gift-rafiki2.png" className={Styles?.imageSearch} />
                                <h2>Lo sentimos, no encontramos ninguna mesa con los datos ingresados.</h2>
                                <p>Intenta de nuevo con otros datos.</p>
                            </div>
                        : 
                            firstT
                                ?
                                    <div className={Styles?.contNoResults}>
                                        <img src="https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/img/gift-rafiki2.png" className={Styles?.imageSearch} />
                                        <h2>Lo sentimos, no encontramos ninguna mesa con los datos ingresados.</h2>
                                        <p>Intenta de nuevo con otros datos.</p>
                                    </div>
                                :
                                    <div className={Styles?.contNoResults}>
                                        <img src="https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/mesa_regalos/img/gift-rafiki.png" className={Styles?.imageSearch} />
                                        <h2>¿Buscando una mesa de regalos?</h2>
                                        <p>Haz tu primera búsqueda y te ayudamos a encontrarla.</p>
                                    </div>
                         

            }
        </div>
    )
}


const SearchTables = () => {

    const [ responseTable, setResponseTable ] = useState(null)
    const [ , setTotal ] = useState(null)
    const [ , setIsEmpty ] = useState(null)
    
    const [ results, setResults ] = useState()
    const [ busqueda, setBusqueda ] = useState()
    const [ selectPage, setSelectPage ] = useState()
    const [ errorService, setErrorService ] = useState()
    const [ searchResults, setSearchResults ] = useState(false)
    const [ initOrder, setInitOrder ] = useState()
    const [ selectOrder, setSelectOrder ] = useState()

    return(
        <>
            <GiftsHeader
                setResponseTable={setResponseTable}
                setTotal={setTotal}
                setIsEmpty={setIsEmpty}
            />
            <div className={searchResults ? `${Styles?.contentSearchSection} ${Styles?.activeSearch}` : Styles?.contentSearchSection}>
                
                <ModuleSearchTable
                    setResults={setResults}
                    setBusqueda={setBusqueda}
                    selectPage={selectPage}
                    setErrorService={setErrorService}
                    setSearchResults={setSearchResults}
                    setInitOrder={setInitOrder}
                    selectOrder={selectOrder}
                />
                <ModuleResults
                    results={results} 
                    errorService={errorService}
                    busqueda={busqueda}
                    setSelectPage={setSelectPage}
                    setSearchResults={setSearchResults}
                    setSelectOrder={setSelectOrder}
                    selectOrder={selectOrder}
                    initOrder={initOrder}
                />
            </div>
        </>
    )
}

// export default SearchTables;

export default compose(
    withLayout, 
    withAgentPage({ fetchTableInfo: true })
)(SearchTables);